import {
  MODEL_REASONING_SELECT_OPTIONS,
  lookupModelReasoningSetting,
  type ModelReasoningSetting,
} from "@winche/shared";
import { Select } from "@winche/ui";

export function ReasoningSelect({
  modelId,
  effortByModel,
  disabled,
  onChange,
  id,
}: {
  modelId: string | null | undefined;
  effortByModel: Record<string, string> | null;
  disabled?: boolean;
  onChange: (modelId: string, effort: ModelReasoningSetting) => void;
  id?: string;
}) {
  if (!modelId) {
    return <span className="text-label text-subtle-foreground">—</span>;
  }
  const value = lookupModelReasoningSetting(modelId, effortByModel);
  const showingBuiltin = effortByModel?.[modelId] == null;
  return (
    <Select
      id={id}
      aria-label={`Reasoning for ${modelId}`}
      disabled={disabled}
      value={value}
      onChange={(e) => onChange(modelId, e.target.value as ModelReasoningSetting)}
      // Full width like the model slots above and below it, so the chevron sits
      // inside the box (the wrapper, not the <select>, sets the width: satellite-16).
      className="md:pointer-fine:min-h-9"
      title={
        showingBuiltin
          ? "Default for this model. Auto follows the operation (eval/CV = low, interview = medium)."
          : "Admin override for this model."
      }
    >
      {MODEL_REASONING_SELECT_OPTIONS.map((opt) => (
        <option key={opt.value} value={opt.value}>
          {opt.label}
          {showingBuiltin && opt.value === value ? " · default" : ""}
        </option>
      ))}
    </Select>
  );
}
